module.exports = __webpack_public_path__ + "media/01-Solicitar-Picking.03ec8397.mp4";